import { v1ApiClient } from '@/services';

import type { SharedLink } from './types';

type UpdateSharedLinkParams = {
  linkId: string;
  link: string;
  expire?: number;
  password?: string;
};
type UpdateSharedLinkResponse = SharedLink;
type UpdateSharedLinkFunction = (
  params: UpdateSharedLinkParams,
) => Promise<UpdateSharedLinkResponse>;

export const updateSharedLink: UpdateSharedLinkFunction = ({
  linkId,
  ...body
}) => v1ApiClient.put(`/shared-link/${linkId}`, body).then((res) => res.data);
